export default __webpack_public_path__ + "static/logo-825e13a64010567e273241307155323b.png";